export const PlatformIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="32"
        height="32"
        rx="5.33333"
        fill="#2F80ED"
        fillOpacity="0.1"
      />
      <g clipPath="url(#clip0_353_2254)">
        <path
          d="M7.11105 11.6478V22.9137C7.11105 24.0001 7.9682 24.889 9.01582 24.889H22.9841C24.0317 24.889 24.8888 24.0001 24.8888 22.9137V11.6478H7.11105ZM20.5777 15.0849C19.8095 15.8882 19.5809 16.7244 19.3206 17.6659C19.0603 18.6009 18.7682 19.6412 17.8603 20.5894C17.1618 21.3137 16.1777 21.6561 15.2317 21.689C14.4507 21.7153 13.6825 21.5441 13.0984 21.1293C12.4063 22.0445 12.038 22.7096 12.038 22.7096C11.9301 22.9005 11.6952 22.9729 11.5047 22.861C11.3142 22.7491 11.2507 22.4989 11.3587 22.3079C11.3587 22.3079 13.1872 18.9499 16.5333 16.7573C14.6476 17.4947 13.1745 18.8116 12.1968 19.898C12.0698 19.5425 11.9872 19.0421 12.0825 18.4231L12.1015 18.3507C12.1015 18.3507 12.4253 17.0141 13.6317 15.8684C14.5777 14.9729 16.0698 14.2026 18.3047 14.2026H18.3111C18.9396 14.2026 19.619 14.2618 20.3682 14.4001C20.6793 14.4594 20.7999 14.8544 20.5777 15.0849ZM22.9841 7.11121H9.01582C7.9682 7.11121 7.11105 8.0001 7.11105 9.08651V10.9894H24.8888V9.08651C24.8888 8.0001 24.0317 7.11121 22.9841 7.11121ZM19.219 9.74495C18.8698 9.74495 18.5841 9.44865 18.5841 9.08651C18.5841 8.72437 18.8698 8.42808 19.219 8.42808C19.5682 8.42808 19.8539 8.72437 19.8539 9.08651C19.8539 9.44865 19.5682 9.74495 19.219 9.74495ZM21.0793 9.74495C20.7301 9.74495 20.4444 9.44865 20.4444 9.08651C20.4444 8.72437 20.7301 8.42808 21.0793 8.42808C21.4285 8.42808 21.7142 8.72437 21.7142 9.08651C21.7142 9.44865 21.4285 9.74495 21.0793 9.74495ZM22.9841 9.74495C22.6349 9.74495 22.3491 9.44865 22.3491 9.08651C22.3491 8.72437 22.6349 8.42808 22.9841 8.42808C23.3333 8.42808 23.619 8.72437 23.619 9.08651C23.619 9.44865 23.3333 9.74495 22.9841 9.74495Z"
          fill="#2F80ED"
        />
      </g>
      <defs>
        <clipPath id="clip0_353_2254">
          <rect
            width="17.7778"
            height="17.7778"
            fill="white"
            transform="translate(7.11105 7.11121)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const RedeemCodeIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="32"
        height="32"
        rx="5.33333"
        fill="#27AE60"
        fillOpacity="0.1"
      />
      <path
        d="M22.0987 24.4816H19.1111C18.399 23.9504 17.2265 23.6245 16.7286 23.5269V19.8315C16.9508 19.8931 17.1783 19.9264 17.4112 19.9264C18.4071 19.9264 19.2878 19.3541 19.6572 18.4662C19.7027 18.3559 19.8232 18.2891 19.9463 18.3045C19.9517 18.3045 19.9758 18.3097 19.9811 18.3097C20.1391 18.3405 20.3024 18.3559 20.4684 18.3559C21.8015 18.3559 22.8857 17.3165 22.8857 16.0385C22.8857 14.9555 22.1228 14.0317 21.0279 13.7827C21.0225 13.7827 21.0172 13.7802 21.0118 13.7802C20.9128 13.7596 20.8324 13.6852 20.8083 13.5902C20.7869 13.5056 20.8083 13.4157 20.8699 13.3541C21.2179 12.9435 21.408 12.4251 21.408 11.8939C21.408 10.6159 20.3238 9.57656 18.9906 9.57656C18.8836 9.57656 18.7765 9.58426 18.6721 9.59709C18.5275 9.61506 18.391 9.51754 18.3696 9.37896L18.3669 9.35586C18.3642 9.34303 18.3642 9.3302 18.3642 9.31737C18.3642 8.03935 17.28 7 15.9469 7C14.6137 7 13.5242 8.03935 13.5242 9.31737C13.5242 9.3302 13.5242 9.34303 13.5215 9.35586L13.5188 9.37896C13.4974 9.5201 13.3609 9.61762 13.2163 9.59709C13.1119 9.58426 13.0048 9.57656 12.8977 9.57656C11.5646 9.57656 10.4804 10.6159 10.4804 11.8939C10.4804 12.4226 10.6705 12.9384 11.0158 13.349C11.0774 13.4132 11.1015 13.503 11.08 13.5902C11.0533 13.6878 10.9756 13.7622 10.8739 13.7827C10.8712 13.7827 10.8659 13.7853 10.8632 13.7853C9.76563 14.0317 9 14.9581 9 16.0411C9 17.3191 10.0842 18.3584 11.4174 18.3584C11.5833 18.3584 11.7466 18.343 11.9046 18.3122C11.9099 18.3097 11.918 18.3097 11.9233 18.3097C12.0465 18.2943 12.1803 18.3584 12.2285 18.4688C12.5979 19.3541 13.4787 19.929 14.4745 19.929C14.7074 19.929 14.9376 19.8982 15.1572 19.834V23.5269C14.9644 23.568 13.5831 23.8683 12.7692 24.4816H9.78704C9.63713 24.4816 9.51667 24.5971 9.51667 24.7408C9.51667 24.8845 9.63713 25 9.78704 25H22.0987C22.2486 25 22.3691 24.8845 22.3691 24.7408C22.3691 24.5971 22.2486 24.4816 22.0987 24.4816Z"
        fill="#007A49"
      />
    </svg>
  );
};

export const SupportIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="32"
        height="32"
        rx="5.33333"
        fill="#EB5757"
        fillOpacity="0.1"
      />
      <g clipPath="url(#clip0_353_2268)">
        <path
          d="M14.803 14.9919C16.742 14.9919 18.303 13.3289 18.303 11.3127C18.303 9.29653 16.721 7.63354 14.803 7.63354C12.885 7.63354 11.303 9.28917 11.303 11.3127C11.303 13.3363 12.864 14.9919 14.803 14.9919Z"
          fill="#EB5757"
        />
        <path
          d="M21.712 6.00001C20.83 5.91907 20.109 6.63283 20.109 7.51583V8.46506C20.172 11.7469 19.486 14.1016 18.149 15.2863C17.967 15.4334 17.806 15.5806 17.631 15.7057C16.833 16.2723 15.846 16.6108 14.81 16.6108C13.592 16.6108 12.486 16.1693 11.604 15.4113C10.141 16.103 9 17.3907 9 19.5541V24.624C9 25.3819 9.581 25.9927 10.302 25.9927H19.311C20.032 25.9927 20.613 25.3819 20.613 24.624V19.5541C20.613 19.4069 20.613 19.2598 20.592 19.1126C20.515 18.0383 20.795 16.9272 21.355 16.0221C22.496 14.1899 23.056 11.6439 23 8.44298V7.61885C23.021 6.81679 22.482 6.08095 21.719 6.00001H21.712ZM17.19 21.2539L15.09 23.4614C14.929 23.6306 14.691 23.6306 14.551 23.4614L12.472 21.2907C11.975 20.7682 11.849 19.9441 12.255 19.3333C12.773 18.5092 13.858 18.4283 14.474 19.1052L14.817 19.4658L15.097 19.1715C15.594 18.649 16.378 18.5166 16.959 18.9434C17.743 19.4658 17.82 20.5843 17.197 21.2612L17.19 21.2539Z"
          fill="#EB5757"
        />
      </g>
      <defs>
        <clipPath id="clip0_353_2268">
          <rect
            width="14"
            height="20"
            fill="white"
            transform="translate(9 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const OrganizationIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="32"
        height="32"
        rx="5.33333"
        fill="#9B51E0"
        fillOpacity="0.1"
      />
      <g clipPath="url(#clip0_423_284)">
        <path
          d="M17.72 23.427V25.987H15.27V23.427C15.27 23.017 15.61 22.677 16.02 22.677H16.97C17.38 22.677 17.72 23.017 17.72 23.427ZM20.71 15.457V25.987H18.83V23.427C18.83 22.407 18 21.567 16.97 21.567H16.02C15 21.567 14.16 22.397 14.16 23.427V25.987H12.27V15.457C12.27 14.987 12.51 14.557 12.92 14.317L15.81 12.597C15.81 12.597 15.81 12.597 15.82 12.597V8.79698C15.82 8.52698 15.98 8.27698 16.24 8.17698L16.48 8.07698C17.14 7.80698 17.89 7.87698 18.5 8.24698C18.73 8.38698 19 8.41698 19.26 8.33698L19.84 8.15698C20.04 8.09698 20.26 8.12698 20.43 8.25698C20.6 8.38698 20.7 8.57698 20.7 8.79698V10.727C20.7 11.017 20.51 11.267 20.24 11.357L19.69 11.537C19.47 11.607 19.23 11.647 19 11.647C18.6 11.647 18.2 11.537 17.85 11.327L17.81 11.307C17.61 11.187 17.38 11.157 17.16 11.197V12.587C17.16 12.587 17.16 12.587 17.17 12.587L20.06 14.307C20.46 14.547 20.71 14.977 20.71 15.437V15.457ZM15.82 18.777C15.82 18.597 15.68 18.457 15.5 18.457H14.66C14.48 18.457 14.34 18.597 14.34 18.777V19.617C14.34 19.797 14.48 19.937 14.66 19.937H15.5C15.68 19.937 15.82 19.797 15.82 19.617V18.777ZM15.82 16.257C15.82 16.087 15.68 15.937 15.5 15.937H14.66C14.48 15.937 14.34 16.087 14.34 16.257V17.097C14.34 17.277 14.48 17.417 14.66 17.417H15.5C15.68 17.417 15.82 17.277 15.82 17.097V16.257ZM18.64 18.777C18.64 18.597 18.49 18.457 18.32 18.457H17.49C17.31 18.457 17.17 18.597 17.17 18.777V19.617C17.17 19.797 17.32 19.937 17.49 19.937H18.32C18.5 19.937 18.64 19.797 18.64 19.617V18.777ZM18.64 16.257C18.64 16.087 18.49 15.937 18.32 15.937H17.49C17.31 15.937 17.17 16.087 17.17 16.257V17.097C17.17 17.277 17.32 17.417 17.49 17.417H18.32C18.5 17.417 18.64 17.277 18.64 17.097V16.257ZM9.67 16.507H11.61V25.987H8V18.187C8 17.257 8.75 16.507 9.68 16.507H9.67ZM10.64 21.227C10.64 21.047 10.49 20.897 10.31 20.897H9.49C9.31 20.897 9.16 21.047 9.16 21.227V22.047C9.16 22.227 9.31 22.367 9.49 22.367H10.31C10.49 22.367 10.64 22.217 10.64 22.047V21.227ZM10.31 18.457H9.49C9.31 18.457 9.16 18.607 9.16 18.777V19.597C9.16 19.777 9.31 19.927 9.49 19.927H10.31C10.49 19.927 10.64 19.777 10.64 19.597V18.777C10.64 18.597 10.49 18.457 10.31 18.457ZM24.99 18.187V25.987H21.37V16.507H23.31C24.24 16.507 24.99 17.257 24.99 18.187ZM23.92 21.227C23.92 21.047 23.77 20.897 23.59 20.897H22.77C22.59 20.897 22.45 21.047 22.45 21.227V22.047C22.45 22.227 22.6 22.367 22.77 22.367H23.59C23.77 22.367 23.92 22.217 23.92 22.047V21.227ZM23.92 18.787C23.92 18.607 23.77 18.467 23.59 18.467H22.77C22.59 18.467 22.45 18.617 22.45 18.787V19.607C22.45 19.787 22.6 19.937 22.77 19.937H23.59C23.77 19.937 23.92 19.787 23.92 19.607V18.787Z"
          fill="#9B51E0"
        />
      </g>
      <defs>
        <clipPath id="clip0_423_284">
          <rect
            width="17"
            height="18.06"
            fill="white"
            transform="translate(8 7.91699)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TransparencyIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="32"
        height="32"
        rx="5.33333"
        fill="#27AE60"
        fillOpacity="0.1"
      />
      <g clipPath="url(#clip0_353_2236)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5658 8.92005V7.18684L9.18823 9.572H10.9159C11.2746 9.57001 11.5638 9.27981 11.5658 8.92005ZM20.3193 23.1555H9.8381C9.37645 23.1535 9.00198 22.7758 9 22.3127V9.94766H10.914C11.4806 9.94766 11.9383 9.48653 11.9403 8.92005V7H20.3193C20.5412 7.00199 20.7552 7.09342 20.9097 7.25243C21.0662 7.41144 21.1534 7.62809 21.1494 7.85071V22.3207C21.1435 22.7798 20.775 23.1495 20.3173 23.1555H20.3193ZM17.5851 14.4099H19.0691V10.5042C19.0691 10.4048 19.0294 10.3094 18.9601 10.2398C18.8907 10.1703 18.7956 10.1305 18.6966 10.1305H17.9556C17.7495 10.1325 17.5851 10.2995 17.5851 10.5042V14.4099ZM15.4195 14.4099H16.9035V12.5674C16.9035 12.3606 16.7371 12.1917 16.529 12.1917H15.8019C15.5958 12.1917 15.4294 12.3606 15.4294 12.5674L15.4195 14.4099ZM13.2559 14.4099H14.7399V11.7425C14.7399 11.5358 14.5735 11.3668 14.3654 11.3668H13.6224C13.4164 11.3668 13.2479 11.5338 13.2479 11.7425L13.2559 14.4099ZM11.0923 14.4099H12.5763V13.3922C12.5763 13.1855 12.4098 13.0186 12.2038 13.0186H11.4667C11.2607 13.0186 11.0923 13.1875 11.0923 13.3942V14.4099ZM16.105 19.2299C16.0991 19.1285 16.0198 19.047 15.9188 19.0411H10.6821C10.587 19.051 10.5137 19.1325 10.5137 19.2299C10.5137 19.3273 10.587 19.4068 10.6821 19.4187H15.9188C15.9683 19.4187 16.0159 19.3989 16.0515 19.3631C16.0872 19.3273 16.105 19.2796 16.105 19.2299ZM19.6714 17.6398C19.6714 17.5901 19.6516 17.5424 19.6159 17.5066C19.5802 17.4708 19.5327 17.453 19.4832 17.453H10.6821C10.5791 17.453 10.4959 17.5364 10.4959 17.6398C10.4959 17.7432 10.5791 17.8266 10.6821 17.8266H19.4752C19.5267 17.8266 19.5743 17.8068 19.61 17.769C19.6456 17.7332 19.6654 17.6835 19.6635 17.6318L19.6714 17.6378V17.6398ZM19.6714 16.0497C19.6714 16 19.6516 15.9523 19.6159 15.9165C19.5802 15.8807 19.5327 15.8629 19.4832 15.8629H10.6821C10.587 15.8728 10.5137 15.9543 10.5137 16.0517C10.5137 16.1491 10.587 16.2286 10.6821 16.2405H19.4752C19.5822 16.2345 19.6635 16.1491 19.6635 16.0417L19.6714 16.0517V16.0497Z"
          fill="#27AE60"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23 9.68926V24.1592C23 24.6223 22.6255 24.998 22.1619 25H11.6807C11.2211 24.996 10.8486 24.6204 10.8486 24.1592V23.5272H20.3193C20.989 23.5272 21.5299 22.9825 21.5318 22.3107V8.84451H22.1619C22.6255 8.8465 23 9.22415 23 9.68926Z"
          fill="#27AE60"
        />
      </g>
      <defs>
        <clipPath id="clip0_353_2236">
          <rect
            width="14"
            height="18"
            fill="white"
            transform="translate(9 7)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PartnerIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="32"
        height="32"
        rx="5.33333"
        fill="#2F80ED"
        fillOpacity="0.1"
      />
      <g clipPath="url(#clip0_423_288)">
        <path
          d="M10.0675 12.9338C10.1718 13.321 10.476 13.6479 10.8845 13.7598C11.8493 14.0265 13.2748 14.1727 14.6308 13.3554C14.7786 13.2694 14.9611 13.2694 15.1002 13.364L22.0799 17.9497C22.2537 18.0615 22.4015 18.2164 22.5145 18.3799V12.5381C22.0886 12.4606 21.541 12.2972 20.8978 12.0993C19.594 11.7035 17.9772 11.2131 16.5344 11.2131C14.5439 11.2131 11.0931 12.5208 10.0588 12.9338H10.0675Z"
          fill="#2F80ED"
        />
        <path
          d="M10.6585 11.0668C9.81539 11.411 9.06788 11.7121 8.47682 11.824V18.4315C8.47682 18.4315 8.47682 18.4917 8.46812 18.5261L10.1892 20.3329C10.7976 20.9696 11.5103 21.4944 12.3013 21.8987L14.4569 22.9742C14.5786 23.0344 14.7177 23.0172 14.822 22.9226C14.9002 22.8537 14.935 22.7591 14.9263 22.6559C14.9089 22.5526 14.8568 22.458 14.7612 22.4064L13.7268 21.8299C13.5182 21.7095 13.44 21.4428 13.5617 21.2363C13.6834 21.0298 13.9441 20.961 14.1614 21.0728L14.8655 21.4686L17.1428 22.5526C17.2993 22.6301 17.4818 22.587 17.5948 22.458C17.6991 22.3375 17.6904 22.2171 17.6817 22.1483C17.673 22.0794 17.6295 21.959 17.4992 21.8815L14.9959 20.4017C14.7872 20.2727 14.7177 20.0146 14.8394 19.8081C14.9698 19.6016 15.2305 19.5328 15.4392 19.6618L16.9516 20.5566L18.5422 21.2277C18.8638 21.3653 19.2289 21.2535 19.4201 20.9524C19.5157 20.7975 19.5505 20.6082 19.507 20.4275C19.4636 20.2469 19.3506 20.092 19.1941 19.9974L16.4822 18.3713C16.2736 18.2508 16.2127 17.9841 16.3344 17.7776C16.4648 17.5711 16.7343 17.5109 16.9342 17.6314L18.4292 18.5261L19.6374 19.2575L20.7761 19.9457C21.0977 20.1436 21.5149 20.0748 21.7583 19.7823C21.906 19.6188 21.9582 19.4037 21.9321 19.1886C21.8973 18.9735 21.7844 18.7929 21.6018 18.6724L14.8394 14.2416C13.2922 15.0675 11.719 14.904 10.6411 14.6029C9.76324 14.3534 9.1461 13.5619 9.1461 12.6585C9.1461 12.4864 9.25041 12.3316 9.41556 12.2627C9.60678 12.1853 14.0137 10.3614 16.5344 10.3614C16.6473 10.3614 16.769 10.37 16.882 10.3786C16.3084 10.1463 15.4131 10.0172 14.3005 10.0172C13.2574 10.0172 11.8754 10.585 10.6585 11.0841V11.0668Z"
          fill="#2F80ED"
        />
        <path
          d="M26 18.4745V12.5381C26 12.2799 25.7914 12.0821 25.5393 12.0821H23.4011V18.9305H25.5393C25.8001 18.9305 26 18.724 26 18.4745Z"
          fill="#2F80ED"
        />
        <path
          d="M5.46068 18.268H7.59892V11.4196H5.46068C5.19992 11.4196 5 11.6261 5 11.8756V17.812C5 18.0701 5.20861 18.268 5.46068 18.268Z"
          fill="#2F80ED"
        />
      </g>
      <defs>
        <clipPath id="clip0_423_288">
          <rect
            width="21"
            height="13"
            fill="white"
            transform="translate(5 10)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const GreenRightChevron = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={5} height={9} fill="none">
      <g clipPath="url(#a)">
        <path
          fill="#007A49"
          d="M.786 0C.352 0 0 .375 0 .838a.87.87 0 0 0 .23.593L3.104 4.5.23 7.569a.88.88 0 0 0 0 1.186.751.751 0 0 0 1.111 0l3.43-3.662a.88.88 0 0 0 0-1.186L1.34.245A.763.763 0 0 0 .786 0Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h5v9H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TreeMapperIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="32"
        height="32"
        rx="5.33333"
        fill="#68B030"
        fillOpacity="0.1"
      />
      <g clipPath="url(#clip0_47_931)">
        <path
          d="M10.5149 20.5058H19.7388L21.7755 26.0171H8.47815L10.5149 20.5058Z"
          stroke="#007A49"
          strokeWidth="1.16316"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M20.7772 5.454C21.0776 5.6712 21.0692 5.90687 21.0374 6.02802C20.927 6.44908 20.3012 6.52896 20.2746 6.53216C20.0248 6.60295 18.7083 7.4779 18.1758 7.90959C18.2975 7.98614 18.415 8.0653 18.5273 8.14647C20.0746 9.26519 20.8524 10.9189 20.9052 13.202C20.9711 16.0532 19.6248 17.4337 17.9205 19.1815L17.6615 19.4474C15.9211 21.2391 15.5888 22.8215 15.5857 22.8372L15.4082 23.725L14.9982 22.9187C14.8046 22.5375 14.5895 22.0912 14.3658 21.6271C13.8718 20.6024 13.312 19.441 12.8788 18.7777C12.8328 18.7072 12.7574 18.6043 12.6614 18.4726C11.8127 17.3092 9.55834 14.2186 10.4783 11.2848C11.0397 9.49444 12.6905 8.10646 15.385 7.15939L16.0076 6.94055L15.7839 7.55886C15.74 7.68008 15.6987 7.80305 15.6597 7.92784C15.7975 7.62812 15.958 7.38989 16.1446 7.23163C17.2653 5.88659 18.4946 4.6258 20.096 5.14379C20.403 5.24312 20.6259 5.34459 20.7772 5.454Z"
          fill="#007A49"
        />
        <path
          d="M15.2781 22.7777C15.2781 22.7777 15.5992 21.122 17.4364 19.2307C19.2736 17.3394 20.6579 16.0661 20.5919 13.2096C20.5337 10.691 19.5877 9.04388 17.6993 7.99025C17.6984 7.98977 17.6976 7.98925 17.6969 7.98871C17.5334 7.87055 19.9178 6.26067 20.2376 6.22224C20.559 6.18364 21.2968 5.86021 19.9988 5.44033C18.7007 5.02045 17.6462 5.91518 16.3671 7.45288C14.7107 8.77282 15.283 17.6701 15.283 17.6701C15.283 17.6701 14.004 11.5576 15.489 7.45339C6.47194 10.6228 12.5032 17.6294 13.1418 18.6073C13.7803 19.5852 14.645 21.5308 15.2781 22.7777ZM15.531 24.6551L14.7184 23.0598C14.524 22.6768 14.3079 22.2286 14.0832 21.7624C13.5933 20.7462 13.0381 19.5944 12.6159 18.9479C12.5719 18.8805 12.4996 18.7821 12.4076 18.6561C11.5337 17.458 9.21224 14.2755 10.1791 11.1921C10.7716 9.30257 12.4881 7.84674 15.2811 6.86506L16.381 6.47845C17.4208 5.32279 18.6491 4.34738 20.1934 4.84688C20.5322 4.95646 20.7835 5.0724 20.9618 5.20131C21.4425 5.54886 21.3735 5.98177 21.3409 6.10617C21.2242 6.55117 20.7559 6.77309 20.3672 6.83405C20.0989 6.94539 19.2669 7.48766 18.711 7.89316C20.3441 9.07238 21.1635 10.8069 21.2187 13.1942C21.2876 16.1763 19.9009 17.5983 18.1453 19.3985L17.8868 19.664C16.2214 21.3784 15.8961 22.8835 15.893 22.8985L15.531 24.6551Z"
          fill="#E9F8EF"
        />
      </g>
      <defs>
        <clipPath id="clip0_47_931">
          <rect
            width="21.3333"
            height="22.0305"
            fill="white"
            transform="translate(5.33325 4.67703)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const FireAlertIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="32"
        height="32"
        rx="5.33333"
        fill="#EB5757"
        fillOpacity="0.1"
      />
      <path
        d="M15.0797 7.02263C15.4993 6.33279 16.5006 6.33279 16.9201 7.02262L26.5081 22.7879C26.9446 23.5056 26.4279 24.4246 25.5879 24.4246H6.41195C5.57191 24.4246 5.05525 23.5056 5.49175 22.7879L15.0797 7.02263Z"
        fill="#E86F56"
      />
      <g clipPath="url(#clip0_47_944)">
        <path
          d="M15.0647 20.5217C15.169 20.5671 15.2789 20.4688 15.2151 20.3874C14.8687 19.9458 14.5408 19.2025 15.0633 18.2453C15.9347 16.6492 16.465 15.8224 16.465 15.8224C16.465 15.8224 16.747 16.7872 17.5115 17.645C18.2473 18.4706 18.6501 19.5089 18.0008 20.3739C17.9399 20.4551 18.0473 20.5509 18.1508 20.5075C18.9546 20.1706 19.856 19.4949 19.9577 18.1502C19.9952 17.7393 19.939 17.164 19.6578 16.4381C19.2962 15.518 18.8516 15.0887 18.5944 14.9043C18.5175 14.8492 18.3978 14.8981 18.4041 14.9817C18.4791 15.9744 18.0233 16.2263 17.7638 15.6586C17.6602 15.4318 17.5998 15.0396 17.5998 14.562C17.5998 13.7668 17.3182 12.9482 16.6975 12.283C16.5361 12.11 16.3472 11.9484 16.1305 11.8106C16.052 11.7606 15.9383 11.8108 15.9455 11.892C15.9932 12.4311 15.95 13.976 14.2958 15.8217C12.7959 17.5338 13.3771 18.8487 13.5834 19.2048C13.9776 19.8871 14.5276 20.2877 15.0647 20.5217Z"
          fill="white"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1031 21.292C16.4358 21.4825 16.7193 21.6383 16.9278 21.8573C17.131 22.0709 17.2185 22.1698 16.8821 21.9914C16.5689 21.8249 16.2727 21.6604 15.8878 21.5395C15.8686 21.5509 15.8484 21.5622 15.8266 21.5746C13.3537 22.9473 10.9771 22.5374 9.91077 18.9738C12.222 18.9115 15.0245 17.6708 16.0457 21.0133C16.0841 21.1374 16.1075 21.2233 16.1031 21.292ZM15.1764 21.0157C13.9826 19.9583 12.0821 20.1004 10.87 19.5111C12.4532 20.8061 12.9297 20.5641 15.1764 21.0157Z"
        fill="white"
      />
      <defs>
        <clipPath id="clip0_47_944">
          <rect
            width="11.0693"
            height="9.27632"
            fill="white"
            transform="translate(10.5134 11.7905)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TracerIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="5.33333" fill="white" />
      <rect
        width="32"
        height="32"
        rx="5.33333"
        fill="#47BB56"
        fillOpacity="0.15"
      />
      <g clipPath="url(#clip0_47_956)">
        <path
          d="M16.4432 17.7035C18.0244 17.7035 19.3063 16.4629 19.3063 14.9325C19.3063 13.4021 18.0244 12.1614 16.4432 12.1614C14.8619 12.1614 13.5801 13.4021 13.5801 14.9325C13.5801 16.4629 14.8619 17.7035 16.4432 17.7035Z"
          fill="#27AE60"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.7912 18.1734C17.9414 19.9637 14.9446 19.9637 13.0948 18.1734C11.245 16.3831 11.245 13.4827 13.0948 11.6924C13.9876 10.8283 15.1804 10.35 16.443 10.35V7.62045C14.5095 7.62045 12.5759 8.3344 11.1006 9.76229C8.1499 12.6181 8.1499 17.248 11.1006 20.1038L16.443 25.2744L21.7854 20.1038C23.2607 18.6759 23.9984 16.8045 23.9984 14.9332H21.1779C21.1779 16.1551 20.684 17.3096 19.7909 18.1737L19.7912 18.1734Z"
          fill="#27AE60"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.2706 7.61829V10.3481H21.1788V13.1625H23.9993V7.61829H18.2706Z"
          fill="#27AE60"
        />
      </g>
      <defs>
        <clipPath id="clip0_47_956">
          <rect
            width="15.1111"
            height="16.8889"
            fill="white"
            transform="translate(8.88879 8.00012)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const RestorationAdviceIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="32"
        height="32"
        rx="5.33333"
        fill="#FFC700"
        fillOpacity="0.1"
      />
      <g clipPath="url(#clip0_47_966)">
        <path
          d="M16.0042 6.22232C15.6854 6.22232 15.4239 6.48361 15.4239 6.80205V8.44324C15.4239 8.76169 15.6854 9.02297 16.0123 9.02297C16.3392 9.02297 16.5925 8.76169 16.5925 8.44324V6.80205C16.5844 6.48361 16.3229 6.22232 16.0042 6.22232ZM9.49926 8.91682C9.35216 8.91682 9.20506 8.97398 9.09066 9.08829C8.86184 9.31692 8.86184 9.68435 9.09066 9.91297L10.2511 11.0724C10.3655 11.1867 10.5126 11.2439 10.6678 11.2439C10.8231 11.2439 10.9702 11.1867 11.0846 11.0724C11.3134 10.8438 11.3134 10.4764 11.0846 10.2477L9.9242 9.08829C9.80979 8.97398 9.66269 8.91682 9.50743 8.91682H9.49926ZM22.5009 8.91682C22.3538 8.91682 22.2067 8.97398 22.0923 9.08829L20.9319 10.2477C20.703 10.4764 20.703 10.8438 20.9319 11.0724C21.0463 11.1867 21.1934 11.2439 21.3486 11.2439C21.5039 11.2439 21.651 11.1867 21.7654 11.0724L22.9258 9.91297C23.1546 9.68435 23.1546 9.31692 22.9258 9.08829C22.8114 8.97398 22.6643 8.91682 22.5091 8.91682H22.5009ZM23.5551 15.4163C23.2364 15.4163 22.9749 15.6776 22.9749 15.996C22.9749 16.3145 23.2364 16.5757 23.5632 16.5757H25.2058C25.5245 16.5757 25.786 16.3145 25.786 15.996C25.786 15.6776 25.5245 15.4081 25.2058 15.4081H23.5632L23.5551 15.4163ZM8.44507 15.4163H6.8025C6.48379 15.4163 6.22229 15.6776 6.22229 15.996C6.22229 16.3145 6.48379 16.5757 6.81067 16.5757H8.45324C8.77195 16.5757 9.03345 16.3145 9.03345 15.996C9.03345 15.6776 8.77195 15.4081 8.45324 15.4081L8.44507 15.4163ZM14.9581 11.9298C15.2033 11.9298 15.4321 12.0849 15.5138 12.3299C15.6119 12.632 15.4485 12.9667 15.1379 13.0647L14.95 13.13L14.7784 13.1954L14.6149 13.2689L14.4515 13.3505L14.2962 13.4485L14.1491 13.5546L14.002 13.6689L13.8631 13.7914L13.7323 13.9221L13.6098 14.0609L13.4954 14.2078L13.3973 14.3548L13.3074 14.51L13.2257 14.6651L13.1521 14.8284L13.0868 14.9917L13.0296 15.1632L12.9887 15.3346L12.956 15.5143L12.9315 15.6939L12.9151 15.8735V16.0695C12.907 16.3879 12.6455 16.6411 12.3268 16.6411C12.3268 16.6411 12.3268 16.6411 12.3186 16.6411C11.9999 16.6411 11.7384 16.3716 11.7466 16.045V15.8327V15.8001L11.7629 15.5878V15.5551L11.7956 15.3428V15.3101L11.8446 15.0978V15.0652L11.9018 14.8611V14.8284L11.9754 14.6243V14.5916L12.0653 14.3956L12.0816 14.363L12.1715 14.167L12.1878 14.1344L12.2859 13.9466L12.3022 13.9139L12.4085 13.7343L12.4248 13.7098L12.5474 13.5301L12.5719 13.5056L12.7027 13.3342L12.7272 13.3097L12.8743 13.1464L12.8988 13.1219L13.0541 12.9667L13.0786 12.9422L13.242 12.7953L13.2665 12.7708L13.4382 12.632L13.4627 12.6156L13.6425 12.4932L13.6751 12.4768L13.8631 12.3625L13.8958 12.3462L14.0837 12.24L14.1164 12.2237L14.3126 12.1339L14.3452 12.1176L14.5495 12.0359H14.5822L14.7865 11.9543C14.8437 11.9379 14.9091 11.9298 14.9663 11.9298H14.9581ZM16.0042 10.0354C12.7108 10.0354 10.0386 12.7055 10.0386 15.996C10.0386 18.119 11.15 19.9888 12.8253 21.0421H19.1831C20.8583 19.9888 21.9697 18.119 21.9697 15.996C21.9697 12.7055 19.2975 10.0273 16.0042 10.0273V10.0354ZM10.6597 20.7563C10.5126 20.7563 10.3655 20.8135 10.2511 20.9278L9.09066 22.0872C8.86184 22.3158 8.86184 22.6833 9.09066 22.9119C9.20506 23.0262 9.35216 23.0834 9.50743 23.0834C9.66269 23.0834 9.80162 23.0262 9.9242 22.9119L11.0846 21.7525C11.3134 21.5238 11.3134 21.1564 11.0846 20.9278C10.9702 20.8135 10.8231 20.7563 10.6678 20.7563H10.6597ZM21.3405 20.7563C21.1934 20.7563 21.0463 20.8135 20.9319 20.9278C20.703 21.1564 20.703 21.5238 20.9319 21.7525L22.0923 22.9119C22.2067 23.0262 22.3538 23.0834 22.5091 23.0834C22.6643 23.0834 22.8032 23.0262 22.9258 22.9119C23.1546 22.6833 23.1546 22.3158 22.9258 22.0872L21.7654 20.9278C21.651 20.8135 21.5039 20.7563 21.3486 20.7563H21.3405ZM12.8171 23.8101C12.8171 23.9652 12.8825 24.1122 12.9887 24.2265C13.0949 24.3326 13.2502 24.398 13.4055 24.398H13.9775V25.2063C13.9775 25.3615 14.0429 25.5084 14.1491 25.6227C14.2553 25.7289 14.4106 25.7942 14.5659 25.7942H17.4588C17.7775 25.7942 18.0472 25.5329 18.0472 25.2063V24.398H18.6192C18.9379 24.398 19.2076 24.1367 19.2076 23.8101V21.8259H12.8416V23.8101H12.8171Z"
          fill="#FFC700"
        />
      </g>
      <defs>
        <clipPath id="clip0_47_966">
          <rect
            width="19.5556"
            height="19.5556"
            fill="white"
            transform="translate(6.22229 6.22232)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const RestorationStandardsIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="32"
        height="32"
        rx="5.33333"
        fill="#6C63FF"
        fillOpacity="0.1"
      />
      <g clipPath="url(#clip0_47_973)">
        <path
          d="M22.1399 12.6097C22.1003 12.5124 22.0542 12.4218 21.9882 12.3413L18.3686 8.30863C18.2862 8.21469 18.1873 8.15094 18.0785 8.09391C17.9533 8.02681 17.8148 7.99997 17.6665 7.99997H10.7602C10.2229 7.99997 9.77783 8.46631 9.77783 9.05007V23.7918C9.77783 24.3823 10.2229 24.8855 10.7602 24.8855H21.2663C21.8036 24.8855 22.2256 24.3789 22.2256 23.7918V13.0559C22.2256 12.8982 22.2025 12.7439 22.1432 12.6063L22.1399 12.6097ZM11.8514 13.0224C11.8514 12.9553 11.9305 12.9284 11.9997 12.9284H15.0589C15.1281 12.9284 15.1809 12.9553 15.1809 13.0224V13.4988C15.1809 13.5591 15.1347 13.6363 15.0589 13.6363H11.9997C11.9305 13.6363 11.8514 13.5625 11.8514 13.4988V13.0224ZM11.8514 18.652C11.8514 18.5849 11.9305 18.558 11.9997 18.558H17.2808C17.35 18.558 17.383 18.5849 17.383 18.652V19.1284C17.383 19.1888 17.3533 19.2659 17.2808 19.2659H11.9997C11.9305 19.2659 11.8514 19.1921 11.8514 19.1284V18.652ZM18.7642 21.9432C18.7642 22.0036 18.7345 22.0808 18.662 22.0808H11.9997C11.9305 22.0808 11.8514 22.0069 11.8514 21.9432V21.4668C11.8514 21.3997 11.9305 21.3729 11.9997 21.3729H18.662C18.7312 21.3729 18.7642 21.3997 18.7642 21.4668V21.9432ZM20.1455 16.3136C20.1455 16.374 20.1158 16.4511 20.0433 16.4511H11.9997C11.9305 16.4511 11.8514 16.3773 11.8514 16.3136V15.8372C11.8514 15.7701 11.9305 15.7432 11.9997 15.7432H20.0466C20.1158 15.7432 20.1488 15.7701 20.1488 15.8372V16.3136H20.1455ZM18.5796 12.5527C18.339 12.5527 18.0983 12.3245 18.0983 12.0561V9.15072L21.174 12.5493H18.5763L18.5796 12.5527Z"
          fill="#6C63FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_47_973">
          <rect
            width="12.4444"
            height="16.8889"
            fill="white"
            transform="translate(9.77783 7.99997)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

// social media icons
export const InstagramIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_793_11)">
        <path
          d="M16 29C23.1797 29 29 23.1797 29 16C29 8.8203 23.1797 3 16 3C8.8203 3 3 8.8203 3 16C3 23.1797 8.8203 29 16 29Z"
          fill="url(#paint0_radial_793_11)"
        />
        <path
          d="M16 29C23.1797 29 29 23.1797 29 16C29 8.8203 23.1797 3 16 3C8.8203 3 3 8.8203 3 16C3 23.1797 8.8203 29 16 29Z"
          fill="url(#paint1_radial_793_11)"
        />
        <path
          d="M15.9998 8.97588C18.2877 8.97588 18.5586 8.98491 19.4617 9.02554C20.297 9.0636 20.7505 9.20293 21.0523 9.32032C21.4523 9.47578 21.7374 9.66155 22.0373 9.96149C22.3373 10.2614 22.523 10.5465 22.6785 10.9465C22.7959 11.2483 22.9352 11.7018 22.9733 12.5371C23.0145 13.4408 23.0229 13.7117 23.0229 15.999C23.0229 18.2863 23.0139 18.5578 22.9733 19.4609C22.9352 20.2962 22.7959 20.7497 22.6785 21.0515C22.523 21.4515 22.3373 21.7366 22.0373 22.0365C21.7374 22.3365 21.4523 22.5222 21.0523 22.6777C20.7505 22.7951 20.297 22.9344 19.4617 22.9725C18.5586 23.0137 18.2877 23.0221 15.9998 23.0221C13.7119 23.0221 13.441 23.0131 12.5379 22.9725C11.7026 22.9344 11.2491 22.7951 10.9473 22.6777C10.5473 22.5222 10.2622 22.3365 9.96229 22.0365C9.66235 21.7366 9.47658 21.4515 9.32113 21.0515C9.20373 20.7497 9.0644 20.2962 9.02635 19.4609C8.98506 18.5572 8.97668 18.2863 8.97668 15.999C8.97668 13.7117 8.98571 13.4402 9.02635 12.5371C9.0644 11.7018 9.20373 11.2483 9.32113 10.9465C9.47658 10.5465 9.66235 10.2614 9.96229 9.96149C10.2622 9.66155 10.5473 9.47578 10.9473 9.32032C11.2491 9.20293 11.7026 9.0636 12.5379 9.02554C13.4416 8.98426 13.7125 8.97588 15.9998 8.97588ZM15.9998 7.43231C13.6732 7.43231 13.381 7.44199 12.467 7.48391C11.5549 7.52584 10.9324 7.67033 10.3874 7.8819C9.82425 8.10057 9.34628 8.39406 8.8696 8.87009C8.39357 9.34613 8.10008 9.8241 7.88141 10.3879C7.66984 10.9329 7.52471 11.5554 7.48343 12.4674C7.4415 13.3815 7.43182 13.673 7.43182 16.0003C7.43182 18.3276 7.4415 18.6191 7.48343 19.5331C7.52535 20.4452 7.66984 21.0677 7.88141 21.6127C8.10008 22.1758 8.39357 22.6538 8.8696 23.1305C9.34564 23.6065 9.82361 23.9 10.3874 24.1187C10.9324 24.3302 11.5549 24.4754 12.467 24.5167C13.381 24.5586 13.6725 24.5683 15.9998 24.5683C18.3271 24.5683 18.6186 24.5586 19.5326 24.5167C20.4447 24.4747 21.0672 24.3302 21.6122 24.1187C22.1753 23.9 22.6533 23.6065 23.13 23.1305C23.606 22.6545 23.8995 22.1765 24.1182 21.6127C24.3298 21.0677 24.4749 20.4452 24.5162 19.5331C24.5581 18.6191 24.5678 18.3276 24.5678 16.0003C24.5678 13.673 24.5581 13.3815 24.5162 12.4674C24.4742 11.5554 24.3298 10.9329 24.1182 10.3879C23.8995 9.82474 23.606 9.34677 23.13 8.87009C22.654 8.39406 22.176 8.10057 21.6122 7.8819C21.0672 7.67033 20.4447 7.5252 19.5326 7.48391C18.6186 7.44199 18.3271 7.43231 15.9998 7.43231Z"
          fill="white"
        />
        <path
          d="M15.9998 11.6005C13.57 11.6005 11.6 13.5705 11.6 16.0003C11.6 18.4301 13.57 20.4001 15.9998 20.4001C18.4296 20.4001 20.3996 18.4301 20.3996 16.0003C20.3996 13.5705 18.4296 11.6005 15.9998 11.6005ZM15.9998 18.8565C14.4227 18.8565 13.1436 17.578 13.1436 16.0003C13.1436 14.4225 14.4221 13.1441 15.9998 13.1441C17.5776 13.1441 18.856 14.4225 18.856 16.0003C18.856 17.578 17.5776 18.8565 15.9998 18.8565Z"
          fill="white"
        />
        <path
          d="M21.2997 12.1537C21.7012 11.7522 21.7012 11.1012 21.2997 10.6997C20.8982 10.2981 20.2472 10.2981 19.8456 10.6997C19.4441 11.1012 19.4441 11.7522 19.8456 12.1537C20.2472 12.5553 20.8982 12.5553 21.2997 12.1537Z"
          fill="white"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_793_11"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12.7768 29) scale(21.7641)"
        >
          <stop stopColor="#FFDD55" />
          <stop offset="0.1" stopColor="#FFDD55" />
          <stop offset="0.5" stopColor="#FF543E" />
          <stop offset="1" stopColor="#C837AB" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_793_11"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(16 -0.721842) scale(16.6141)"
        >
          <stop stopColor="#3771C8" />
          <stop offset="0.13" stopColor="#3771C8" />
          <stop offset="1" stopColor="#6600FF" stopOpacity="0" />
        </radialGradient>
        <clipPath id="clip0_793_11">
          <rect
            width="26"
            height="26"
            fill="white"
            transform="translate(3 3)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LinkedinIcon = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_793_22)">
        <path
          d="M12.9994 26.0003C20.1791 26.0003 25.9995 20.1799 25.9995 13.0002C25.9995 5.82037 20.1791 0 12.9994 0C5.81957 0 -0.000793457 5.82037 -0.000793457 13.0002C-0.000793457 20.1799 5.81957 26.0003 12.9994 26.0003Z"
          fill="#0065CA"
        />
        <path
          d="M8.99281 10.2219H6.45082C6.2224 10.2219 6.03723 10.4071 6.03723 10.6355V20.5576C6.03723 20.786 6.2224 20.9712 6.45082 20.9712H8.99281C9.22123 20.9712 9.4064 20.786 9.4064 20.5576V10.6355C9.4064 10.4071 9.22123 10.2219 8.99281 10.2219Z"
          fill="white"
        />
        <path
          d="M21.108 14.3355C21.108 14.3869 21.108 14.4385 21.108 14.4898C21.1053 15.1734 21.1025 15.8585 21.1025 16.5403V20.6242C21.1025 20.8182 20.9495 20.9712 20.7555 20.9712H18.0788C17.8907 20.9712 17.7318 20.8182 17.7318 20.6242V15.7079C17.7318 15.0137 17.8155 14.2552 17.4053 13.647C17.2223 13.3755 16.9514 13.165 16.645 13.0505C16.3661 12.9463 16.0558 12.9213 15.7674 12.9955C15.4528 13.0765 15.1767 13.271 14.9522 13.5059C14.7277 13.7408 14.5502 14.0157 14.3785 14.2913C14.2542 14.491 14.1895 14.6596 14.1962 14.8948C14.1983 14.9654 14.1962 15.0366 14.1962 15.1071V20.5595C14.1962 20.7889 14.0138 20.9712 13.7844 20.9712H11.2431C11.0137 20.9712 10.8313 20.7889 10.8313 20.5595V10.6353C10.8313 10.4059 11.0137 10.2235 11.2431 10.2235H13.7844C14.0138 10.2235 14.1962 10.4059 14.1962 10.6353V11.8775C14.1962 11.978 14.18 12.0801 14.1989 12.1799C14.2209 12.1192 14.2878 12.0529 14.3233 11.9961C14.3724 11.9176 14.4219 11.8394 14.4726 11.7621C14.5719 11.6112 14.6754 11.4627 14.7885 11.3216C15.0102 11.0449 15.2708 10.7938 15.586 10.6264C16.0213 10.3952 16.5274 10.3381 17.0201 10.3304C17.4881 10.3231 17.9591 10.357 18.4127 10.4725C19.2728 10.6915 19.98 11.2355 20.4611 11.9765C20.6303 12.238 20.772 12.5175 20.8805 12.8092C20.9751 13.0636 21.0549 13.3199 21.0778 13.5902C21.0989 13.838 21.1062 14.0866 21.1077 14.3352L21.108 14.3355Z"
          fill="white"
        />
        <path
          d="M7.72178 9.39981C8.92899 9.39981 9.90762 8.42117 9.90762 7.21397C9.90762 6.00677 8.92899 5.02814 7.72178 5.02814C6.51458 5.02814 5.53595 6.00677 5.53595 7.21397C5.53595 8.42117 6.51458 9.39981 7.72178 9.39981Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_793_22">
          <rect width="26" height="26" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const YoutubeIcon = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_793_4)">
        <path
          d="M12.9998 25.9997C20.1794 25.9997 25.9997 20.1794 25.9997 12.9998C25.9997 5.82023 20.1794 0 12.9998 0C5.82023 0 0 5.82023 0 12.9998C0 20.1794 5.82023 25.9997 12.9998 25.9997Z"
          fill="#FF0000"
        />
        <path
          d="M20.9455 12.6545C20.9309 11.7597 20.8925 10.8659 20.7674 9.97898C20.7225 9.66086 20.6724 9.33688 20.5662 9.03602C20.3054 8.29527 19.7613 7.85505 18.9886 7.73132C18.4791 7.64959 17.9623 7.60335 17.4469 7.56949C15.784 7.46041 14.1179 7.43274 12.4521 7.44837C11.3962 7.45846 10.3399 7.48679 9.2846 7.52814C8.66041 7.55256 8.0372 7.61019 7.41529 7.6675C7.06527 7.69973 6.71687 7.75737 6.3994 7.92538C5.81787 8.2321 5.47403 8.71432 5.3389 9.35219C5.22787 9.87641 5.17154 10.4078 5.13116 10.9415C5.0693 11.7581 5.0413 12.576 5.0553 13.3949C5.06897 14.1927 5.10316 14.9894 5.20182 15.7816C5.24447 16.1241 5.29136 16.4703 5.38318 16.8017C5.61339 17.6291 6.1731 18.1201 7.01642 18.2676C7.42148 18.3383 7.83305 18.3871 8.24396 18.4076C9.33539 18.4627 10.4278 18.4975 11.5196 18.5385C11.7006 18.5454 11.8823 18.5431 12.0633 18.546C12.0972 18.5463 12.1307 18.5528 12.1643 18.5564H13.8356C13.9141 18.5519 13.9922 18.545 14.0707 18.5431C14.8193 18.5252 15.5685 18.52 16.3161 18.4871C17.0295 18.4558 17.7422 18.4031 18.4543 18.3454C18.7962 18.3178 19.1404 18.2758 19.4601 18.1367C20.1214 17.8492 20.5122 17.3422 20.6613 16.6428C20.7736 16.116 20.829 15.5817 20.8694 15.0454C20.9293 14.2496 20.9582 13.4529 20.9452 12.6548L20.9455 12.6545ZM11.4105 15.3821V10.6152C12.7888 11.4094 14.1599 12.1996 15.5463 12.9987C14.1593 13.798 12.7894 14.5873 11.4105 15.3821Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_793_4">
          <rect width="26" height="26" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const FacebookIcon = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_819_18)">
        <path
          d="M19.0246 5.32927C19.0248 6.40523 19.0248 7.48119 19.0246 8.55715C19.0246 8.73805 19.013 8.73948 18.8324 8.72832C18.256 8.69302 17.6789 8.67615 17.1013 8.70807C16.7354 8.72832 16.3761 8.78127 16.028 8.89819C15.2797 9.14944 14.8611 9.68826 14.6882 10.4397C14.6144 10.7608 14.5782 11.0868 14.5775 11.4165C14.5766 11.8966 14.5765 12.3769 14.5768 12.8571C14.5768 13.0102 14.5808 13.014 14.7357 13.014C16.0139 13.0142 17.292 13.0142 18.5702 13.0142C18.6099 13.0142 18.65 13.0179 18.6892 13.0135C18.7881 13.0024 18.8165 13.0393 18.7966 13.1377C18.742 13.4102 18.6946 13.684 18.6444 13.9573C18.4718 14.8979 18.2991 15.8385 18.1267 16.7791C18.0913 16.973 18.092 16.9733 17.8917 16.9733C16.8482 16.9734 15.8048 16.9733 14.7614 16.9734C14.5769 16.9734 14.5765 16.974 14.5765 17.1612V25.7399C14.5765 25.7947 14.5768 25.8331 14.5822 25.8594C14.0636 25.9225 13.5356 25.9549 13 25.9549C11.917 25.9549 10.865 25.8223 9.85934 25.5722C9.86297 25.5604 9.86466 25.546 9.86427 25.5288C9.86362 25.4927 9.86505 25.4566 9.86505 25.4205V17.1775C9.86505 17.0416 9.79826 16.9736 9.66468 16.9734C8.892 16.9733 8.11933 16.9734 7.34665 16.9731C7.18443 16.9731 7.18015 16.969 7.18015 16.8113C7.18002 15.598 7.18002 14.3849 7.18015 13.1718C7.18015 13.0168 7.18275 13.0144 7.33809 13.0144C8.11427 13.0141 8.89057 13.0142 9.66688 13.0141C9.79882 13.0141 9.86488 12.9497 9.86505 12.8209C9.86531 12.2107 9.8548 11.6002 9.86842 10.9903C9.88854 10.0852 9.99184 9.19122 10.2764 8.32498C10.8184 6.67594 11.9338 5.62879 13.5946 5.15135C14.2713 4.95682 14.9639 4.87143 15.6662 4.84015C16.7365 4.79253 17.7919 4.90725 18.841 5.10411C19.0253 5.13863 19.0246 5.14434 19.0246 5.32927Z"
          fill="white"
        />
        <path
          d="M26 12.3375V13.6807C25.9875 13.8097 25.9727 13.9384 25.963 14.0675C25.8885 15.0621 25.6955 16.034 25.388 16.982C24.6163 19.3601 23.2743 21.3593 21.3617 22.968C19.4453 24.5797 17.2381 25.5485 14.7592 25.8986C14.6337 25.9164 14.5944 25.9201 14.5822 25.8595C14.5767 25.8331 14.5765 25.7947 14.5765 25.7399V17.1612C14.5765 16.9741 14.5769 16.9734 14.7614 16.9734C15.8048 16.9733 16.8482 16.9734 17.8917 16.9733C18.0919 16.9733 18.0913 16.973 18.1267 16.7792C18.2991 15.8385 18.4718 14.8979 18.6444 13.9573C18.6946 13.684 18.742 13.4102 18.7966 13.1377C18.8165 13.0393 18.788 13.0025 18.6892 13.0135C18.65 13.0179 18.6099 13.0143 18.5702 13.0143C17.292 13.0143 16.0139 13.0143 14.7357 13.014C14.5808 13.014 14.5767 13.0102 14.5767 12.8571C14.5765 12.377 14.5766 11.8967 14.5775 11.4165C14.5782 11.0869 14.6144 10.7609 14.6882 10.4397C14.8611 9.68829 15.2797 9.14947 16.028 8.89822C16.3761 8.7813 16.7354 8.72835 17.1012 8.7081C17.6789 8.67618 18.256 8.69305 18.8324 8.72835C19.0129 8.73951 19.0246 8.73808 19.0246 8.55718C19.0247 7.48122 19.0247 6.40526 19.0246 5.3293C19.0246 5.14437 19.0253 5.13866 18.841 5.10414C17.7919 4.90728 16.7364 4.79256 15.6662 4.84018C14.9639 4.87146 14.2713 4.95685 13.5946 5.15138C11.9338 5.62882 10.8183 6.67597 10.2764 8.32501C9.99182 9.19125 9.88852 10.0853 9.8684 10.9903C9.85478 11.6003 9.86529 12.2107 9.86503 12.8209C9.86503 12.9496 9.79897 13.0141 9.66686 13.0141C8.89055 13.0143 8.11424 13.0141 7.33806 13.0144C7.18272 13.0144 7.18013 13.0169 7.18013 13.1718C7.18 14.3849 7.18 15.5981 7.18013 16.8113C7.18013 16.969 7.18441 16.9732 7.34663 16.9732C8.1193 16.9734 8.89198 16.9733 9.66466 16.9734C9.79815 16.9734 9.86494 17.0415 9.86503 17.1776V25.4206C9.86503 25.4566 9.8636 25.4927 9.86425 25.5288C9.86464 25.546 9.86295 25.5605 9.85932 25.5723C9.84764 25.6112 9.81468 25.6214 9.7616 25.6059C9.73746 25.5987 9.71241 25.5941 9.68802 25.5876C7.00052 24.8651 4.7514 23.4436 2.98492 21.2967C0.829888 18.6775 -0.14835 15.6558 0.0181506 12.2659C0.0622738 11.3682 0.198407 10.4841 0.443291 9.62016C1.23349 6.83183 2.70357 4.58258 4.84899 2.87865C5.48748 2.37149 6.18593 1.91261 6.94407 1.50213C7.10252 1.41635 7.26215 1.33433 7.42294 1.25634C7.42475 1.2553 7.42657 1.25439 7.42852 1.25361C8.62309 0.673654 9.87904 0.304446 11.1851 0.126007C11.1877 0.125617 11.1904 0.125228 11.1931 0.124968C11.603 0.0691656 12.0179 0.0321799 12.4373 0.0133627C12.6293 0.0046678 12.8212 0.000255479 13.013 0.000125705C13.534 -0.000263618 14.0537 0.0306226 14.5715 0.0943418C14.5866 0.0961586 14.6015 0.0979754 14.6166 0.0999221C14.7894 0.121854 14.9622 0.147419 15.1345 0.176619C15.8507 0.298217 16.5415 0.471725 17.2067 0.697273C18.9317 1.28165 20.485 2.21472 21.866 3.49339C23.0605 4.59932 24.0092 5.8911 24.7176 7.35793C25.382 8.7338 25.7907 10.1819 25.9412 11.7025C25.9621 11.914 25.9804 12.1258 26 12.3375Z"
          fill="#0766FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_819_18">
          <rect width="26" height="25.9548" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const VTOChallengeIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 5.33333C0 2.38782 2.38781 0 5.33333 0H26.6667C29.6122 0 32 2.38781 32 5.33333V26.6667C32 29.6122 29.6122 32 26.6667 32H5.33333C2.38782 32 0 29.6122 0 26.6667V5.33333Z"
        fill="#2F80ED"
        fillOpacity="0.1"
      />
      <g clipPath="url(#clip0_642_5418)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.0017 16.9848V16.8898L11.3931 19.3633L7.22983 19.5535C6.4728 19.6484 5.99976 20.3144 5.99976 20.9805C6.09429 21.6465 6.56733 22.1223 7.32437 22.1223H7.4189L12.1498 21.8367C12.5283 21.6465 12.9068 21.5512 13.0958 21.1707L14.515 19.0777C13.9474 18.6019 13.1904 17.9359 13.0013 16.9848H13.0017Z"
          fill="#2F80ED"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.4423 14.9078L22.3739 14.3477C22.3739 14.3477 21.4442 12.0141 21.3509 11.8274C20.7931 10.5203 19.863 9.6801 17.9107 9.21369L14.7493 8.28049C14.3774 8.28049 14.1915 8.28049 13.9126 8.46721L10.4724 10.8942C10.1935 11.1742 10.1005 11.5477 10.2864 11.9211C10.4724 12.2945 10.9372 12.3879 11.3091 12.2945L14.6567 10.5211L16.7024 10.9879L16.1446 11.9215L14.006 15.002C13.6341 15.7488 13.4482 16.309 13.6341 16.8688C13.7271 17.4289 14.2849 17.9891 14.7497 18.3625L18.1899 20.416L16.2372 25.4571C15.9583 26.0172 16.3302 26.6707 16.981 27.0442H17.4458C17.9107 27.0442 18.3759 26.7641 18.6548 26.2039L20.7935 20.416C20.9794 19.8559 20.7935 19.109 20.3286 18.9223L17.1673 16.9621L19.6778 13.3215L20.8868 15.7485C20.9798 15.9352 21.3517 16.0285 21.5376 16.0285L25.2567 16.3086C25.5357 16.402 25.9075 16.0285 26.0009 15.7485C26.0009 15.375 25.8149 14.9082 25.4431 14.9082L25.4423 14.9078Z"
          fill="#2F80ED"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.5793 9.41758H22.0347C23.2187 9.14141 23.9476 7.94492 23.7652 6.74844C23.4918 5.73594 22.5812 5 21.5793 5H21.1238C19.9398 5.36797 19.1199 6.47266 19.4843 7.66875C19.5754 8.68125 20.5773 9.41719 21.5793 9.41719V9.41758Z"
          fill="#2F80ED"
        />
      </g>
      <defs>
        <clipPath id="clip0_642_5418">
          <rect
            width="20"
            height="22.043"
            fill="white"
            transform="translate(6 5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const MangrovesChallengeIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="32"
        height="32"
        rx="5.33333"
        fill="#EB5757"
        fillOpacity="0.1"
      />
      <g clipPath="url(#clip0_642_5426)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.2359 21.7084C18.0065 21.4782 17.7778 20.9015 17.6631 20.5558C17.5484 20.4403 17.6631 19.8651 17.6631 19.7489V18.942C17.7778 18.7118 17.7778 18.3661 17.6631 18.1351C17.4337 17.9049 17.5484 17.6747 17.6631 17.3282C17.6631 17.098 17.7778 16.5213 18.0065 16.2911C18.3498 15.7152 18.9241 15.3687 19.4968 15.254C19.5735 15.1775 19.6494 15.1385 19.7262 15.1385C19.9556 15.023 20.2989 15.023 20.5291 15.023C20.9871 14.9075 21.4467 14.9075 21.9047 14.9075C22.1341 15.023 22.248 15.023 22.4774 14.9075C22.4774 14.9075 22.5921 15.023 22.4774 14.792C22.3627 14.6765 22.1341 14.6765 22.0194 14.6765C21.5614 14.561 21.2165 14.561 20.7585 14.561C20.5291 14.561 20.4151 14.561 20.4151 14.2153C20.6445 13.6394 21.3327 13.6394 21.5621 13.2929C21.6389 13.2164 21.6389 13.1774 21.5621 13.1774C21.3327 13.2929 20.9894 13.4076 20.7592 13.4076C20.1865 13.6378 20.0718 13.7533 19.7269 14.0983C19.3836 14.3285 19.1542 14.5587 18.8094 14.5587C18.58 14.5587 18.3513 14.5587 18.1219 14.6742C18.1219 13.8673 18.4653 12.8309 18.9248 12.0241C19.0395 11.6784 19.1542 11.4481 19.3828 11.1017C19.4975 10.9862 19.4975 10.8715 19.4975 10.6413C19.2681 10.6413 19.1542 10.987 19.0395 11.1017C18.8101 11.3319 18.6962 11.5621 18.5815 11.7923C18.1235 12.4829 18.0088 10.8699 18.0088 10.6397C18.0088 10.5242 18.1235 9.94907 18.0088 9.83279C17.8941 9.94829 17.8941 10.2932 17.8941 10.2932C17.7794 10.6389 17.7794 10.8691 17.7794 11.1001C17.6647 11.5605 17.6647 12.0225 17.6647 12.3674C17.55 13.058 17.55 13.2898 17.3214 13.8649C16.6339 15.1322 16.4038 16.6305 16.2891 18.0126C16.1744 17.2057 16.0597 16.3996 15.9458 15.4772C15.8311 15.247 15.8311 15.0167 15.8311 14.6703C15.7164 14.4401 15.8311 13.9796 15.9458 13.6332C16.0605 13.0573 16.2891 12.4806 16.2891 11.7899C16.2891 11.6745 16.4038 10.7528 16.4038 10.6373C16.2891 10.5219 16.1744 10.8676 16.1744 10.8676C16.0597 11.328 16.0597 11.7899 15.945 12.2504C15.8303 12.4806 15.487 13.403 15.1421 13.403C15.0274 13.403 14.9127 13.1727 14.7988 13.0573C14.6841 12.827 14.5694 12.5968 14.4554 12.4813C14.1121 12.0209 13.9974 11.7907 13.6525 11.4442C13.5378 11.214 13.4231 11.0985 13.3092 10.9838C13.1945 10.8683 13.0798 10.9838 13.0798 10.9838C13.0798 11.3295 13.3092 11.5597 13.5378 11.7907C13.8812 12.1364 14.1106 12.8278 14.3407 13.1735C14.5701 13.9804 14.5701 14.671 14.5701 15.4787C13.6525 15.3632 13.1945 15.3632 12.3916 15.4787C11.9336 15.4787 11.474 15.7089 11.016 15.8244C11.016 15.8244 10.9013 15.9399 10.9013 16.0546C11.2446 16.0546 11.5887 15.9391 11.9336 15.8244C12.621 15.7089 13.5386 15.9399 14.1121 16.4003C14.4554 16.746 14.7995 17.2072 15.0297 17.6676C15.2591 18.3583 15.1444 18.2435 15.2591 18.935C15.2591 19.2807 15.2591 19.5109 15.1444 19.8573C15.1444 20.0875 15.1444 20.3178 15.0297 20.6642C14.915 20.8944 14.8003 21.0099 14.8003 21.2401C14.6856 21.5858 14.457 21.8161 14.1129 21.9308C13.5402 22.161 13.6549 22.0463 13.0806 21.9308C12.3932 21.8153 12.5079 22.3912 11.8197 22.3912H11.705C11.1323 22.2757 10.7874 22.2765 10.3294 22.5067C9.98605 22.6222 9.75665 22.6222 9.41178 22.5067H8.60889L8.95221 22.6222C9.29553 22.6222 9.8698 22.8524 10.2131 22.7377C10.5564 22.6222 10.6711 22.5075 11.016 22.6222C11.1307 22.6222 11.5887 22.7377 11.7034 22.7377C11.8181 22.9679 11.5887 23.4283 11.474 23.5446C11.2446 23.8903 11.016 23.8903 10.6711 24.1205C10.6711 24.236 10.4417 24.4662 10.4417 24.4662C10.4417 24.4662 10.7851 24.236 10.8998 24.1205C11.1292 24.005 11.3578 23.8903 11.5872 23.6601C12.0452 23.3143 12.1599 22.8532 12.6195 22.5075C12.7342 22.5075 12.7342 22.392 12.8489 22.392C13.0783 22.392 13.1922 22.7377 13.7665 22.7377H13.9959C14.1106 22.6222 14.2253 22.6222 14.4539 22.6222C14.5686 22.7377 14.7972 22.8524 14.5686 22.9679C14.4539 23.0834 14.1106 23.3136 13.9959 23.4283C13.6905 23.6585 13.3844 23.8122 13.0783 23.8887C12.3909 24.1189 12.046 24.5793 11.588 24.9258C11.2446 25.156 11.0152 25.0413 10.7851 25.156C10.6704 25.2715 10.7851 25.2715 10.8998 25.2715C11.2818 25.195 11.6259 25.0413 11.9321 24.8111C12.1615 24.6956 12.735 24.2352 13.079 24.3507C13.3084 24.4662 13.1937 24.6964 13.079 24.8111C12.9644 25.0413 12.9644 25.2715 12.7357 25.5017C12.5063 25.6172 12.3924 25.7319 12.163 25.9621L11.8197 26.3078C11.8197 26.3078 11.4764 26.538 11.5903 26.6535L11.8197 26.538C12.0491 26.4225 12.0491 26.3078 12.2777 26.1923C12.3924 26.0768 12.5071 25.9621 12.7357 25.8466C13.3084 25.3862 13.4231 25.156 13.6533 24.4638C13.8827 24.1181 13.9966 24.0034 14.226 23.7732C14.4554 23.6577 14.7988 23.543 15.0289 23.543H15.1436C15.2583 23.6585 15.373 24.0034 15.487 24.1189C15.7164 24.4646 15.945 24.6948 16.0597 25.156C16.0597 25.3862 15.945 25.7319 15.945 26.0784V26.6543C15.945 26.6543 15.945 27 16.0597 26.8845C16.1744 26.8845 16.1744 26.4241 16.1744 26.3086C16.1744 26.1931 16.1744 25.5017 16.5177 25.3862C16.7471 25.3862 17.0904 25.6164 17.2051 25.8466C17.3198 26.0768 17.4345 26.1923 17.5484 26.4225C17.6631 26.4225 18.1212 26.9984 18.2359 26.9984C18.0065 26.6527 17.6631 26.3078 17.433 25.9613C17.2028 25.6149 17.2036 25.5009 16.7455 25.1544C16.6308 25.039 16.5161 25.039 16.4022 24.8087C16.4022 24.6933 16.2875 24.3483 16.1728 24.2328V24.1173C15.9434 23.5414 16.1728 23.4267 16.4022 23.0802C16.5169 22.9647 16.6316 22.85 16.8602 22.85C17.2036 22.7345 17.5477 22.9655 17.7778 23.1957C18.2359 23.6561 18.3506 23.8864 18.3506 24.3483C18.4653 24.9242 18.58 24.9242 18.8086 25.3854C18.9233 25.7311 18.9233 26.0761 19.038 26.4225C19.1527 26.538 19.1527 26.307 19.1527 26.307C19.1527 25.9613 19.038 25.6164 18.9233 25.2699C18.9233 25.1544 18.6939 24.8095 18.8086 24.5793C18.9233 24.4638 19.038 24.5793 19.1519 24.6948C19.2666 24.8103 19.3813 24.925 19.6099 25.0405C19.7246 25.156 19.9532 25.2707 20.1826 25.3862C20.526 25.6164 20.6407 25.9621 20.7554 26.3086C20.7554 26.4241 20.8701 26.769 20.9848 26.769C21.0995 26.6535 20.9848 26.5388 20.9848 26.4233C20.8701 26.0776 20.8701 25.7327 20.5267 25.3862C20.2973 25.156 19.8393 24.8103 19.6091 24.5793C19.1511 24.1189 18.8063 23.8887 18.6916 23.312C18.6916 22.9663 18.8063 22.9663 19.0349 22.8516C19.3782 22.7361 19.6076 22.9671 19.8378 23.1973C20.1811 23.6577 20.5252 24.0042 21.0987 24.1197C21.3281 24.2352 21.442 24.2352 21.6714 24.3499C21.9008 24.3499 21.5567 24.2344 21.5567 24.2344C21.2134 24.0042 20.8693 24.0042 20.6391 23.6585C20.5244 23.543 20.5244 23.3128 20.7538 23.3128H21.5567C22.2441 23.4283 22.4743 23.4283 23.047 22.9671C23.3903 22.8516 23.505 22.7369 23.8499 22.7369H24.1932C24.27 22.7369 24.3079 22.6986 24.3079 22.6214H23.7352C23.0478 22.6214 22.9323 23.1973 22.1302 23.0818C21.7869 23.0818 21.5575 22.9663 21.2126 22.9663C20.9832 22.8508 20.6399 22.8508 20.295 22.7361C19.837 22.6206 19.837 22.3904 19.4921 22.2757C19.1488 22.0455 18.8047 22.2757 18.5745 22.0455L18.2312 21.6998L18.2359 21.706V21.7084Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.7965 8.11053C13.9936 8.57095 13.8789 9.83826 14.5671 10.5304C15.4847 9.95453 15.4847 8.68722 14.7965 8.11053Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.6309 7.65012C15.7134 7.88032 15.1406 9.03292 15.5987 9.83982C16.6309 9.60961 17.089 8.57251 16.6309 7.65012Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.0064 8.57251C16.9741 8.57251 16.2867 9.4949 16.4014 10.532C17.4337 10.532 18.235 9.60961 18.0064 8.57251Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.8474 11.1071C12.5041 10.1847 11.4718 9.72433 10.5542 10.1847C10.8975 11.2218 11.9298 11.5675 12.8474 11.1071Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.9427 5.46042C15.1398 5.92083 14.9104 7.07343 15.4847 7.76561C16.4023 7.41991 16.6317 6.1526 15.9427 5.46042Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.0767 8.22681C12.2738 8.91743 12.3893 10.07 13.3061 10.6467C13.9935 9.95609 13.8788 8.68722 13.0767 8.22681Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.7083 15.14C22.7083 16.1771 23.6258 16.8678 24.5419 16.6375C24.5419 15.7152 23.6243 14.9098 22.7083 15.14Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.4781 11.2226C22.2487 10.3002 22.9361 9.37939 23.9684 9.37939C24.1978 10.3018 23.5104 11.2226 22.4781 11.2226Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.415 8.68721C20.5297 9.72431 19.7276 10.5304 18.6953 10.4149C18.6953 9.37783 19.4982 8.57172 20.415 8.68721Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.3828 6.72772C19.9555 7.53462 19.6122 8.68721 18.6953 9.03291C18.1226 8.22602 18.4659 7.07342 19.3828 6.72772Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.0193 9.6096C21.7899 10.532 20.7584 11.1071 19.8408 10.7622C20.0702 9.7251 21.1017 9.14919 22.0193 9.6096Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.2738 9.8398C12.5032 8.8027 11.8158 7.88031 10.7835 7.88031C10.5541 8.8027 11.2415 9.8398 12.2738 9.8398Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.9749 5.80688C16.5169 6.61378 17.0896 7.76638 18.0072 7.99658C18.4652 7.07419 18.0072 6.03709 16.9749 5.80688Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.8732 15.14C20.7585 16.1772 21.6761 16.9833 22.7069 16.7531C22.7069 15.8307 21.7893 15.0253 20.8732 15.14Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.0001 13.527C24.8854 14.4494 23.7392 15.0245 22.9363 14.6796C23.051 13.7572 24.0833 13.1821 25.0001 13.527Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.1091 10.8769C15.0267 10.6467 15.8288 11.3373 15.8288 12.2597C15.0259 12.4899 14.1091 11.7993 14.1091 10.8769Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.6243 11.9148C22.7067 12.0303 22.0193 12.9519 22.3634 13.8743C23.281 13.8743 23.9684 12.8372 23.6243 11.9148Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.7908 10.6459C22.5937 11.2218 22.4782 12.4892 21.6761 13.0658C20.9887 12.3752 20.9887 11.2226 21.7908 10.6459Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.6938 12.9503C19.4967 13.5262 20.6437 13.1805 20.9871 12.2597C20.1842 11.6838 19.0372 12.0295 18.6938 12.9503Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.14697 16.4081C8.94987 17.0988 10.0969 16.8686 10.5549 16.0624C9.86746 15.3718 8.72124 15.4865 8.14697 16.4081Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.7012 15.3702C11.3578 14.4478 10.2109 13.9874 9.40796 14.5633C9.63736 15.4857 10.7836 15.9461 11.7012 15.3702Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.3255 18.0211C11.2431 18.1366 12.1591 17.2142 12.0452 16.2934C11.0129 16.1779 10.2116 16.984 10.3255 18.0211Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.5349 12.2597C12.8474 11.5691 11.7012 11.5691 11.127 12.3752C11.6997 13.1821 12.9606 13.0658 13.5349 12.2597Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.5347 14.6796C13.1913 13.6425 12.159 13.2968 11.2415 13.7572C11.5848 14.6796 12.7318 15.14 13.5347 14.6796Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.06372 11.7985C9.75114 12.4891 10.8974 12.3744 11.4716 11.5683C10.7842 10.8777 9.52174 10.9924 9.06372 11.7985Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.7835 13.758C10.5541 12.8356 9.40787 12.3752 8.60498 12.8356C8.83438 13.758 9.98059 14.2184 10.7835 13.758Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.1089 8.3423C14.3383 7.41991 13.5362 6.49908 12.5039 6.49908C12.3892 7.42147 13.0766 8.3423 14.1089 8.3423Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.7584 9.26311C20.529 8.34072 21.2164 7.30362 22.2487 7.30362C22.4781 8.34072 21.7906 9.26311 20.7584 9.26311Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 14.4486C7.68742 15.1393 8.83363 15.0245 9.40791 14.1029C8.72049 13.4123 7.45802 13.6425 7 14.4486Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.0129 9.8398C10.6696 8.91741 9.63732 8.45699 8.71973 8.91741C9.06305 9.8398 10.0953 10.3002 11.0129 9.8398Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.1089 5C15.0265 5.46041 15.3698 6.61301 14.6816 7.30519C13.764 6.95949 13.5346 5.80768 14.1089 5Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.6186 7.88033C12.6186 6.95794 11.5863 6.26732 10.6687 6.49753C10.6687 7.53463 11.701 8.22525 12.6186 7.88033Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.3328 6.15259C20.4152 6.15259 19.7278 7.18969 20.0719 8.11208C20.9895 7.99659 21.6769 7.07498 21.3328 6.15259Z"
          fill="#EB5757"
        />
      </g>
      <defs>
        <clipPath id="clip0_642_5426">
          <rect
            width="18"
            height="22"
            fill="white"
            transform="translate(7 5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
